import {HTTP} from './http_service';

export const fetchCampaigns = function () {
  return HTTP.post('/online/poster-filler/campaigns?field=&order=&query=');
};

export const fetchPaperFormatsFromCampaign = function (campaign_id) {
  return HTTP.post('/online/poster-filler/paper-formats?field=&order=&query=',
    {campaign_id: campaign_id},
  );
};

export const fetchTemplatesFromCampaignAndPaperFormat = function (
  campaign_id, paper_format_id) {
  return HTTP.post('/online/poster-filler/templates?field=&order=&query=',
    {
      campaign_id: campaign_id,
      format_id: paper_format_id,
    },
  );
};

export const fetchThemesFromPaperFormat = function (paper_format_id) {
  return HTTP.post('/online/poster-filler/themes?field=&order=&query=',
    {paper_format_id: paper_format_id},
  );
};

export const fetchTemplateFromId = function (template_id) {
  return HTTP.post('/ajax/template/' + template_id + '?field=&order=&query=');
};

export const fetchSelectorPack = function (posterId) {
  let params = (posterId !== undefined && posterId !== null) ? posterId : '';
  let url = `/online/poster-filler/selector-pack/${params}?field=&order=&query=`;
  return HTTP.post(url).then((response) => response.data);
};

export const fetchTemplateContentById = function (template_id) {
  return HTTP.post('/online/poster-filler/template-content/' + template_id).then((response) => {
    return response.data;
  });
};

export const fetchTemplateColors = function (templateId) {
  return HTTP.get(`/ajax/colors/template/${templateId}`).then((response) => {
    return response.data;
  });
};

export default {
  fetchSelectorPack,
  fetchTemplateContentById,
  fetchCampaigns,
  fetchTemplateFromId,
  fetchTemplateColors,
  fetchThemesFromPaperFormat,
  fetchPaperFormatsFromCampaign,
  fetchTemplatesFromCampaignAndPaperFormat,
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/services/selector_service.js